import { memo } from 'react';
import { FaQuoteLeft } from 'react-icons/fa';

import styles from './Testimonial.module.css';

interface TestimonialPanelProps {
  isReccomender?: boolean;
}

const TestimonialPanel = ({ isReccomender }: TestimonialPanelProps) => {
  const someTestText = isReccomender;
  return (
    <div className={styles.testimonialPanel}>
      <div className={styles.title}>Be Inspired by Students Like You</div>
      <div className={styles.testimonialContainer}>
        <div className={styles.imageContainer}>
          <img
            src="https://res.cloudinary.com/highereducation/images/v1750288580/BestColleges.com/f2e7ce0357ceb192e2927f6d3a96fd00036b735c/f2e7ce0357ceb192e2927f6d3a96fd00036b735c.png?_i=AA"
            alt="Femail Portrait"
            className={styles.testimonialImage}
          />
        </div>
        <span className={styles.quoteIcon}>
          <FaQuoteLeft size={16} />
        </span>
        <p>
          <span className={styles.quote}>&quot;</span>It wasn&apos;t until I enrolled that I realized how many
          opportunities there are and how many different ways you can piece together the things that you love to create
          the perfect job for you.&quot;
        </p>
      </div>
      <div className={styles.sourceContainer}>
        <p className={styles.sourceText}>- Taylor, A College Graduate Who Pursued Their Passion</p>
        <p className={styles.disclaimer}>Taylor is not an alumni of this school</p>
      </div>
    </div>
  );
};

export default memo(TestimonialPanel);
